export enum DepositStatus {
  /**
   * 未缴纳
   */
  NOT_PAY = 0,

  /**
   * 已冻结
   */
  FREEZEN = 1,

  /**
   * 已申请解冻
   */
  APPLY_UNFREEZE = 2,

  /**
   * 已解冻部分保证金
   */
  PART_UNFREEZEN = 3,

  /**
   * 已解冻
   */
  UNFREEZEN = 4,
  /**
   * 已扣除违约金(违约金=保证金))
   */
  DEBITED = 5
}

export const DepositStatusTextMap = {
  [DepositStatus.NOT_PAY]: '未缴纳',
  [DepositStatus.FREEZEN]: '已冻结',
  [DepositStatus.APPLY_UNFREEZE]: '已申请解冻',
  [DepositStatus.PART_UNFREEZEN]: '已解冻部分保证金',
  [DepositStatus.UNFREEZEN]: '已解冻',
  [DepositStatus.DEBITED]: '已扣除违约金'
}

export const DepositStatusColorMap = {
  [DepositStatus.NOT_PAY]: 'warning',
  [DepositStatus.FREEZEN]: 'default',
  [DepositStatus.APPLY_UNFREEZE]: 'processing',
  [DepositStatus.PART_UNFREEZEN]: 'processing',
  [DepositStatus.UNFREEZEN]: 'success',
  [DepositStatus.DEBITED]: 'error'
}
